
// Ajax cart JS for Drawer and Cart Page
const drawerSelectors = {
  cartIcons: document.querySelectorAll('.header__icon--cart'),
  cartIconDesktop: document.querySelector('#cart-icon-desktop'),
  cartIconMobile: document.querySelector('#cart-icon-mobile'),
};
class ajaxCart extends HTMLElement {
    constructor() {
      super();
  
      this.openeBy = drawerSelectors.cartIcons;
      this.isOpen =  this.classList.contains('open--drawer');
      this.bindEvents();
  
      if(window.globalVariables.template != 'cart'){
        this.addAccessibilityAttributes(this.openeBy);
        this.getCartData();
      }else{
        this.style.visibility = 'visible';
      }
      if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

	if ( ! window.ajaxCarts ) {
		window.ajaxCarts = [];
	}

	window.ajaxCarts.push( this );
    }
  
    /**
     * Observe attribute of component
     * 
     * @returns {array} Attributes to Observe
     */
    static get observedAttributes() {
      return ['updating'];
    }
  
    /**
     * To Perform operation when attribute is changed
     * Calls attributeChangedCallback() with params when attribute value is updated
     * 
     * @param {string} name attribute name
     * @param {string} oldValue attribute Old value
     * @param {string} newValue attribute latest value
     */
    attributeChangedCallback(name, oldValue, newValue) {
      // called when one of attributes listed above is modified
      if(name == 'updating' && newValue == 'false'){
        this.updateEvents();
      }
    }
  
    /**
     * Add accessibility attributes to Open Drawer buttons
     * 
     * @param {Node Array} openDrawerButtons Cart Icons
     */
    addAccessibilityAttributes(openDrawerButtons) {
      let _this = this;
      openDrawerButtons.forEach(element => {
        element.setAttribute('role', 'button');
        element.setAttribute('aria-expanded', false);
        element.setAttribute('aria-controls', _this.id);
      });
    }
  
    /**
     * Escape Click event to close drawer when focused within Cart Drawer
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;
      this.querySelector('.close-ajax--cart').dispatchEvent(new Event('click'));
    }
  
    /**
     * bind dclick and keyup event to Cart Icons
     * bind keyUp event to Cart drawer component
     * bind Other inside element events
     *
     */
    bindEvents() {
      if(window.globalVariables.template != 'cart'){
        this.openeBy.forEach(cartBtn => cartBtn.addEventListener('click', this.openCartDrawer.bind(this)));
        this.addEventListener('keyup', this.onKeyUp.bind(this));
      }
      this.updateEvents();
    }

    /**
     * bind Other inside element events to DOM
     *
     */
    updateEvents(){
      this.querySelectorAll('.close-ajax--cart').forEach(button => button.addEventListener('click', this.closeCartDrawer.bind(this)));
      this.querySelectorAll('[data-itemRemove]').forEach(button => button.addEventListener('click', this.removItem.bind(this)));
      this.querySelectorAll('[data-qty-btn]').forEach(button => button.addEventListener('click', this.manageQtyBtn.bind(this)));
      this.querySelectorAll('[data-qty-input]').forEach(button => button.addEventListener('click', this.onQtyChange.bind(this)));
    }
  
    /**
     * Open Cart drawer and add focus to drawer container
     *
     * @param {event} Event instance
     */
    openCartDrawer(event) {
      if(!window.globalVariables.cart_drawer){
        window.location.href = window.routes.cart_fetch_url || '/cart';
        return;
      }
  
      if(document.querySelector('#mobile-menu-drawer').classList.contains('opened-drawer')){
        document.querySelector('.close-mobile--navbar').dispatchEvent(new Event('click'));
      }
  
      this.classList.add('opened-drawer');
      siteOverlay.prototype.showOverlay();
      
      Utility.forceFocus(this.querySelector('.cart-title'));
      let closeBtn = this.querySelector('.close-ajax--cart');
      Utility.trapFocus(this, closeBtn);

      if(document.querySelector('.swell-tab') != null){
        document.querySelector('.swell-tab').style.display="none";
      }
      if(document.querySelector('#chat-button') != null){        
        document.querySelector('#chat-button').style.display="none";
      }
  
      if(event){
        event.preventDefault();
        let openBy = event.currentTarget;
        openBy.setAttribute('aria-expanded', true);
      }

		// The below code initializes Giftship's features on the drawer style cart

		if ( typeof( Gs ) == 'object' && typeof( Gs.initializeDrawer ) == 'function' ) {
			Gs.initializeDrawer();
		}
    }
  
    /**
     * Close Cart drawer and Remove focus from drawer container
     *
     * @param {event} Event instance
     */
    closeCartDrawer(event, elementToFocus = false) {
      if (event !== undefined) {
        event.preventDefault();
        this.classList.remove('opened-drawer');
        siteOverlay.prototype.hideOverlay();
        let openByEle = event.currentTarget;
        openByEle.setAttribute('aria-expanded', false);
        Utility.removeTrapFocus(elementToFocus);
  
        let actionBtn = drawerSelectors.cartIconDesktop;
        if(window.innerWidth < 1024){
          actionBtn = drawerSelectors.cartIconMobile;
        }
        if(document.querySelector('.swell-tab') != null){
          document.querySelector('.swell-tab').style.display="";
        }
        if(document.querySelector('#chat-button') != null){        
          document.querySelector('#chat-button').style.display="";
        }
        Utility.forceFocus(actionBtn);
      }
    }
  
    /**
     * Update cart HTML and Trigger Open Drawer event
     *
     * @param {string} cartHTML String formatted response from fetch cart.js call
     * @param {string} action Open Drawer as value if need to Open Cart drawer
     */
     async _updateCart(response, action){
      this.setAttribute('updating', true);
      
      // Convert the HTML string into a document object
      let cartHTML = '';
      if(window.globalVariables.template != 'cart') {
        cartHTML = response['template-ajax-cart'];
      }else{
        cartHTML = response['template-cart'];
      }

      if(cartHTML == null) return;
      let parser = new DOMParser();
      cartHTML = parser.parseFromString(cartHTML, 'text/html');

      let cartElement = cartHTML.querySelector('ajax-cart');
      this.innerHTML = cartElement.innerHTML;
      this.setAttribute('updating', false);

      let headerHTML = new DOMParser().parseFromString(response['header'], 'text/html');
      let cartIcon = headerHTML.getElementById('cart-icon-desktop');
      if(drawerSelectors.cartIconDesktop) drawerSelectors.cartIconDesktop.innerHTML = cartIcon.innerHTML;
      if(drawerSelectors.cartIconMobile) drawerSelectors.cartIconMobile.innerHTML = cartIcon.innerHTML;
      
      
      if(window.globalVariables.cart_drawer == true && action == 'open_drawer' && window.globalVariables.template != 'cart'){
          this.openCartDrawer();
      }
      if (document.querySelector('[data-is_freeShipping]') != null) {
        let freeShipping=document.querySelector('[data-is_freeShipping]').getAttribute('data-is_freeShipping');
        if (freeShipping == 'true') {
          document.querySelector('[data-freeShiping_text] p').innerHTML=`${window.globalVariables.settings.free_shipping_txt} <span class="d-block text-center">(*Canadian Customer charge will be $10)</span>`;
        }
      }
      var header1 = {
        method: 'GET', 
        headers: {
            'Content-Type': 'application/json',
          }
      };
      await fetch(`${window.routes.cart_fetch_url}.json`, header1)
      .then(function(response) {
        return response.json();
      })
      .then(async data => {
          window.globalVariables.cart=data;
      }).catch(e => {
          console.log(e);
      });
      // this._removeDummyProduct();
    }
     _removeFreeGift(){
      for (let [i,gift] of window.globalVariables.cart.items.entries() ) {
        if (gift.properties.product_type == 'free_gift') {
          let obj=
            {
              'line': i+1,
              'quantity': 0
            }
          var header = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(obj),
          };
          fetch(`${routes.cart_change_url}.js`, header)
          .then(function(response) {
            return response.json();
          })
          .then( data => {
              this.getCartData();
          }).catch(e => {
              console.log(e);
          });
        }
      }
      
    }
    // _addFreeGift(){
    //   this._removeFreeGift();
    //   setTimeout(() => {
    //     console.log(window.globalVariables.cart,'add');
    //     let freeGiftId=document.querySelector('[data-found_gift]').getAttribute('data-found_gift');
    //     if (freeGiftId.length > 0) {
    //       let obj=
    //           {
    //             quantity: 1,
    //             id: parseInt(freeGiftId),
    //             properties: {
    //               'product_type': 'free_gift',
    //             }
    //           }
    //       var header = {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json',
    //         },
    //         body: JSON.stringify(obj),
    //       };
    //       fetch('/cart/add.js', header)
    //       .then(function(response) {
    //         return response.json();
    //       })
    //       .then( data => {
    //           this.getCartData();
    //       }).catch(e => {
    //           console.log(e);
    //       });
    //     }
    //   }, 2000);
      
    // }
    /**
     * Fetch latest cart data 
     *
     * @param {string} action Open Drawer as value if need to Open Cart drawer or else let it be empty
     */
      async getCartData(action){
        let fetchCart = "";
        
        if( window.globalVariables.template == "cart") {
          fetchCart = fetch(`${routes.cart_fetch_url}?sections=template-cart,header`);
        }else{
           fetchCart = fetch(`${routes.cart_fetch_url}?sections=template-ajax-cart,header`);
        }
        // if(window.globalVariables.template != 'cart') fetchCart = fetch(`${routes.cart_fetch_url}?sections=template-ajax-cart,header`);
        await fetchCart.then( response => {
          return response.json();
        }).then((response)=>{  
          this._updateCart(response, action);
        }).catch(function(e){
            console.log(e,'e')
        }).finally(() => {
            // Cart HTML fetch done
        });
    }
  
     /**
     * Update Quantity API call 
     *
     * @param {string} line Line Index value of cart Item (Starts from 1)
     * @param {integer} quantity Quantity to update
     */
    updateItemQty(line, quantity){
        let lineItem = document.querySelectorAll('[data-cart-item]')[line-1];

        if(lineItem){ lineItem.classList.add('updating'); }
        const body = JSON.stringify({
            line,
            quantity
        });
        if (document.querySelector('[data-source-attribute]') != null) {
          document.querySelector('[data-source-attribute]').remove();
		const additionalCheckoutButtons = document.getElementById('additional-checkout-buttons');
		if ( additionalCheckoutButtons ) {
			additionalCheckoutButtons.innerHTML = "";
		}
        }
        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body }})
        .then((response) => {
            return response.text();
        })
        .then((state) => {
          this.getCartData();
          

          // this._addFreeGift();
          
          setTimeout(() => {
            if(lineItem){ lineItem.classList.remove('updating'); }
            if (document.querySelector('[data-source-attribute]') == null) {
              var po = document.createElement('script');
              po.type = 'text/javascript';
              po.async = true;
              po.setAttribute('data-source-attribute','shopify.dynamic_checkout.cart.init')
              po.src = 'https://cdn.shopify.com/shopifycloud/payment-sheet/assets/latest/dynamic-checkout-cart.en.js';
              var s = document.getElementsByTagName('script')[0];
              s.parentNode.insertBefore(po, s);
            }
          }, 1000);
        }).catch((error) => {
          setTimeout(() => {
            if(lineItem){ lineItem.classList.remove('updating'); }
          }, 1000);
          console.log(error);
        });
    }
  
    /**
     * Remove Item Event
     *
     * @param {event} Event instance
     */
    removItem(event){
      event.preventDefault();
      let currentTarget = event.currentTarget;
      let itemIndex = currentTarget.dataset.index || null;
      if(itemIndex != null){
          this.updateItemQty(itemIndex, 0);
      }
    }
  
    /**
     * Cart Item Qunatity Increment/Decrement Button event
     *
     * @param {event} Event instance
     */
    manageQtyBtn(event){
      event.preventDefault();
      let currentTarget = event.currentTarget;
      let action = currentTarget.dataset.for || 'increase';
      let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
      let itemIndex = $qtyInput.dataset.index || 1;
      let currentQty = parseInt($qtyInput.value) || 1;
      let finalQty = 1;
  
      if(action == 'decrease' && currentQty <= 1){
          return false;
      }else if(action == 'decrease'){
          finalQty = currentQty - 1;
      }else{
          finalQty = currentQty + 1;
      }
      this.updateItemQty(itemIndex, finalQty);
    }

    /**
     * Cart Item Qunatity Input change event
     *
     * @param {event} Event instance
     */
    onQtyChange(event){
      const $qtyInput = event.currentTarget;
      const qtyValue = $qtyInput.value;
      const itemIndex = $qtyInput.dataset.index || null;
      if(itemIndex) this.updateItemQty(itemIndex, qtyValue);
    }
    _removeDummyProduct(){
      let dummy_line_no=parseInt(document.querySelector('[data-cart-dummy_line]').getAttribute('data-cart-dummy_line'));
      if (dummy_line_no == 1 && window.globalVariables.cart.items.length == 1) {
         this.updateItemQty(dummy_line_no,0)
      }
    }
  
}
customElements.define("ajax-cart", ajaxCart);

